export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/30">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-base text-background-50"></i>
              </div>
              <span className="text-foreground-50 font-bold text-lg">桔子影院</span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed">
              高清免费在线观影平台，热播电视剧、热门电影即点即播，流畅不缓冲。每日更新最新影视内容，为你带来极致的在线观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-100 font-semibold text-sm mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors cursor-pointer">热门推荐</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors cursor-pointer">专题合集</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-100 font-semibold text-sm mb-4">合作伙伴</h4>
            <p className="text-foreground-600 text-sm leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-100 font-semibold text-sm mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-9 h-9 rounded-lg bg-background-200/60 flex items-center justify-center cursor-pointer text-foreground-400 hover:text-primary-400 hover:bg-background-300/60 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-9 h-9 rounded-lg bg-background-200/60 flex items-center justify-center cursor-pointer text-foreground-400 hover:text-primary-400 hover:bg-background-300/60 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-9 h-9 rounded-lg bg-background-200/60 flex items-center justify-center cursor-pointer text-foreground-400 hover:text-primary-400 hover:bg-background-300/60 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 桔子影院 · 高清免费在线观看平台
          </p>
          <p className="text-foreground-700 text-xs">
            本站内容仅供学习交流，请在24小时内删除
          </p>
        </div>
      </div>
    </footer>
  );
}